import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const HeroSection: React.FC = () => {
  return (
    <section className="relative bg-gradient-to-br from-primary/5 via-background to-secondary/5 pt-32 pb-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-4xl mx-auto">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-primary/10 rounded-full mb-6">
            <Icon name="Cpu" size={20} className="text-primary" />
            <span className="text-sm font-medium text-primary">Enterprise-Grade AI Platform</span>
          </div>
          
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-foreground mb-6">
            Advanced AI Technology
            <span className="block text-primary mt-2">Built for Scale</span>
          </h1>
          
          <p className="text-lg md:text-xl text-text-secondary mb-8 max-w-3xl mx-auto">
            Explore our cutting-edge architecture, AI algorithms, and technical specifications that power intelligent video analytics at enterprise scale.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button 
              variant="default" 
              size="lg"
              iconName="FileCode"
              iconPosition="left"
            >
              View API Documentation
            </Button>
            <Button 
              variant="outline" 
              size="lg"
              iconName="Download"
              iconPosition="left"
            >
              Download Technical Specs
            </Button>
          </div>
          
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mt-12 pt-12 border-t border-border">
            <div className="text-center">
              <div className="text-3xl font-bold text-primary mb-2">99.9%</div>
              <div className="text-sm text-text-secondary">Uptime SLA</div>
            </div>
            <div className="text-center">
              <div className="text-3xl font-bold text-primary mb-2">&lt;100ms</div>
              <div className="text-sm text-text-secondary">API Response</div>
            </div>
            <div className="text-center">
              <div className="text-3xl font-bold text-primary mb-2">50M+</div>
              <div className="text-sm text-text-secondary">Daily Requests</div>
            </div>
            <div className="text-center">
              <div className="text-3xl font-bold text-primary mb-2">256-bit</div>
              <div className="text-sm text-text-secondary">Encryption</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;